module.exports = __webpack_public_path__ + "img/Assets-02.ed66b283.png";